import { GET_WORKER_IMPORT_TYPE, GET_WORKER_IMPORT_TYPE_ERROR } from "../../actions/types";

const initialState = {
    importTypeList: [],
}

export const workerImport = (state = initialState, action) => {
    switch (action.type) {

        case GET_WORKER_IMPORT_TYPE:
            return {
                ...state,
                importTypeList: action.payload.data,
            };
        case GET_WORKER_IMPORT_TYPE_ERROR:
            return {
                ...state,
                importTypeList: [],
            };

        default:
            return state;
    }
}

